<template>
  <router-view :project="project" />
</template>

<script>
import { mapMutations } from 'vuex'

import Project from '@/models/Project'

export default {
  data () {
    return {
      project: new Project()
    }
  },
  computed: {
    projectSecondaryMenu () {
      return [
        {
          name: this.$t('overview'),
          link: { name: 'project-details', params: { name: this.projectId } },
          icon: 'home'
        },
        {
          name: this.$tc('activities._', 2),
          link: { name: 'project-activities', params: { name: this.projectId } },
          icon: 'assignment'
        },
        {
          name: this.$t('expenses._'),
          link: { name: 'project-expenses', params: { name: this.projectId } },
          icon: 'attach_money'
        },
        // {
        //   name: 'Phases',
        //   link: { name: 'project-phases', params: { name: this.projectId } }
        // },
        {
          name: this.$t('edit'),
          link: { name: 'project-edit', params: { name: this.projectId } },
          icon: 'mode_edit'
        }
      ]
    },
    projectId () {
      return this.$route.params.name
    }
  },
  async mounted () {
    await this.updateProject()
  },
  destroyed () {
    this.setSecondaryNav(null)
  },
  methods: {
    ...mapMutations('navigation', [
      'setPageTitle',
      'setSecondaryNav'
    ]),
    async updateProject () {
      this.project = new Project()
      await this.project.fetch(this.$route.params.name)

      this.setPageTitle(this.project.name)
      this.setSecondaryNav(this.projectSecondaryMenu)
    }
  },
  async beforeRouteUpdate (to, from, next) {
    if (to.params.name !== from.params.name) {
      await this.updateProject()
    }

    next()
  }
}
</script>

<style>

</style>
